var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"sky__header"},[_c('desktop-top-bar',{attrs:{"configuration":_vm.configuration}}),_vm._v(" "),_c('mobile-top-bar',{attrs:{"configuration":_vm.configuration}}),_vm._v(" "),(!_vm.isCheckout)?_c('menu-wrapper'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }